import {
  DetailsList,
  Link,
  Panel,
  PanelType,
  SearchBox,
  SelectionMode,
} from "@fluentui/react";
import {
  getContractors,
  IPagedCollection,
  IContractor,
} from "../../services/assetServices";
import { useEffect, useState } from "react";
import { useSetAtom } from "jotai";
import { errorMessageAtom, isInProgressAtom } from "../../atoms/messageBarAtoms";

export interface IContractorSelectorProps {
  isOpen: boolean;
  hideContractorSelector: any;
  onContractorSelected: (id: number) => void;
}

const ContractorSelector = (props: IContractorSelectorProps) => {
  const [contractors, setContractors] = useState<IContractor[]>([]);

  const setErrorMessage = useSetAtom(errorMessageAtom);
  const setIsInProgress = useSetAtom(isInProgressAtom);

  const fetchData = async () => {
    const abortController = new AbortController();
    setIsInProgress(true);
    try {
      const abortController = new AbortController();
      const contractors = await getContractors(abortController, 10, 1);
      setContractors(contractors.items);
    } catch (error: any) {
      setErrorMessage(error.message);
    } finally {
      setIsInProgress(false);
    }
    return () => {
      abortController.abort();
    };
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <Panel
      isLightDismiss
      isOpen={props.isOpen}
      onDismiss={props.hideContractorSelector}
      closeButtonAriaLabel="Close"
      type={PanelType.medium}
      headerText="Pick contractor for selected work order"
    >
      <SearchBox
        placeholder="Search contractor"
        onSearch={(newValue) => {
          const abortController = new AbortController();
          getContractors(abortController, 10, 1, newValue).then(
            (contractors: IPagedCollection<IContractor>) => {
              setContractors(contractors.items);
            }
          );
        }}
        onClear={() => setContractors([])}
      />
      <DetailsList
        columns={[
          {
            key: "Id",
            name: "Id",
            fieldName: "id",
            minWidth: 50,
            maxWidth: 50,
            isResizable: true,
            onRender: (item) => (
              <Link
                key={item.id}
                onClick={() => {
                  props.onContractorSelected(item?.id);
                }}
              >
                {item.id}
              </Link>
            ),
          },
          {
            key: "Code",
            name: "Code",
            fieldName: "code",
            minWidth: 100,
            maxWidth: 125,
            isResizable: true,
          },
          {
            key: "Name",
            name: "Name",
            fieldName: "name",
            minWidth: 250,
            maxWidth: 250,
            isResizable: true,
          },
        ]}
        compact={true}
        items={contractors}
        selectionMode={SelectionMode.none}
      />
    </Panel>
  );
};

export default ContractorSelector;
